/* eslint-disable
    import-x/order
*/
// Fix any style issues and re-enable lint.
import Modal from 'ui-library/modals/Modal';
import PropTypes from 'prop-types';
import React from 'react';

import * as EntityDAO from 'dao/EntityDAO';
import * as UserDAO from 'dao/UserDAO';
import * as ModalContainer from 'ui-library/ModalContainer';
import * as benchlingUtil from 'BenchlingUtil';
import * as InstitutionModalConstants from './InstitutionModalConstants';
import EntityStore from 'stores/EntityStore';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import notifications from 'notifications';
import preferences from 'Preferences';
import staticURL from 'lib/staticURL';

function setInstitution(institutionUrlIdentifier, modalKey) {
  LoadingScreen.show();
  EntityDAO.setInstition(EntityStore.currentUser().id, institutionUrlIdentifier)
    .done((institution) => {
      notifications.success(`You have been added to ${institution.name}.`);
      UserDAO.acceptInstitutionTerms(EntityStore.currentUserId);
      ModalContainer.close(modalKey);
    })
    .fail(notifications.notifyError)
    .always(() => LoadingScreen.hide());
}

function dismissModal(modalKey) {
  ModalContainer.close(modalKey);
  preferences.set(
    InstitutionModalConstants.InstitutionPreferences.DISMISSED_BROAD_INSTITUTION_MODAL,
    new Date().toISOString()
  );
}

function BroadBasicModalInfo() {
  return (
    <div>
      <div className="text-center institution-modal-header-image">
        <img
          src={staticURL('/static/img/institution/broad-institute.png')}
          height={48}
          className="u-spacing-right"
        />
        <img src={staticURL('/static/img/benchling-wordmark.svg')} height={48} className="u-spacing-left" />
      </div>
      <p>
        The Broad Institute has partnered with Benchling to provide a more{' '}
        <strong>integrated, secure experience</strong> for its scientists.
      </p>
      <p>
        Verified Broad accounts use Benchling within the security and backup requirements of the Broad
        Institute by gaining the following benefits:
      </p>
      <ul>
        <li>
          Projects will <strong>automatically be backed up</strong> to Broad servers, eliminating the need for
          periodic data exports
        </li>
        <li>Direct login through SSO with a Broad email is enforced</li>
        <li>
          Basic information about scientist accounts (email address, organizations, activity) will be
          periodically sent to the Broad Institute to ensure quality of Benchling experience
        </li>
      </ul>
    </div>
  );
}

function BroadBaseModal(props) {
  return (
    <Modal enableRedesign={false} title="Broad Institute" buttons={props.buttons} closeable={false}>
      <BroadBasicModalInfo />
      {props.children}
    </Modal>
  );
}
BroadBaseModal.propTypes = {
  buttons: PropTypes.array.isRequired,
  children: PropTypes.node,
};

function BroadSettingsModal() {
  return (
    <BroadBaseModal
      buttons={[
        {
          text: 'OK',
          style: 'default',
          onClick: () => ModalContainer.close(InstitutionModalConstants.BROAD_SETTINGS_MODAL_KEY),
        },
      ]}
    />
  );
}

export function BroadGoogleAuthModal() {
  return (
    <BroadBaseModal
      buttons={[
        {
          text: 'Link Broad Account',
          style: 'primary',
          onClick: () =>
            benchlingUtil.redirectToLinkGoogleAccount(InstitutionModalConstants.BROAD_URL_IDENTIFIER),
        },
        {
          text: 'I am a Guest',
          style: 'default',
          onClick: () => {
            dismissModal(InstitutionModalConstants.InstitutionScheduledModal.BROAD_GOOGLE_AUTH_MODAL_KEY);
          },
        },
      ]}
    >
      <div>If you are a member of the Broad institute, link your Broad account as your Google email.</div>
    </BroadBaseModal>
  );
}

export function BroadSetInstitutionModal() {
  return (
    <BroadBaseModal
      buttons={[
        {
          text: 'Join Broad',
          style: 'primary',
          onClick: () =>
            setInstitution(
              InstitutionModalConstants.BROAD_URL_IDENTIFIER,
              InstitutionModalConstants.InstitutionScheduledModal.BROAD_SET_INSTITUTION_MODAL_KEY
            ),
        },
        {
          text: 'Not now',
          style: 'default',
          onClick: () => {
            dismissModal(InstitutionModalConstants.InstitutionScheduledModal.BROAD_SET_INSTITUTION_MODAL_KEY);
          },
        },
      ]}
    >
      <div>To get started, connect your account to the Broad institute.</div>
    </BroadBaseModal>
  );
}

export function BroadInfoLink() {
  return (
    <div>
      <p>
        As a member of the Broad Institute, you have special{' '}
        <a
          onClick={() =>
            ModalContainer.open(InstitutionModalConstants.BROAD_SETTINGS_MODAL_KEY, <BroadSettingsModal />)
          }
        >
          security and privacy features
        </a>{' '}
        enabled on your account.
      </p>
    </div>
  );
}
